import {
  WagesListParamsType,
  WagesListResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getWagesList/getWagesListQuery.type';
import { wagesListQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getWagesList/getWagesListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getWagesListQueryOptions = (params: WagesListParamsType) =>
  queryOptions({
    queryKey: ['get_wages_list', params],
    queryFn: () => wagesListQueryFunction(params),
    select: (data: WagesListResponseType) => {
      return {
        count: data?.count,
        total_price: data?.total_price,
        wages: data?.wages?.map((item) => ({ ...item })),
        id: data?.wages?.map((item) => ({ id: item?.id })),
        cartData: data?.wages?.map((item) => [
          { name: 'نوع تعمیر:', value: item?.title, id: item?.id },
          {
            name: 'قیمت :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.price)} ریال`,
            id: item?.id,
          },
        ]),
      };
    },
  });
